export const Brand = {
    GENERIC : 1,
    MS : 2
}